import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex } from '@chakra-ui/react';
import { Button } from '@whitbread-eos/atoms';
import { renderSanitizedHtml } from '@whitbread-eos/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CookiePolicies(_ref) {
  var _labels$cookieConsent, _cookiePolicies$intro, _cookiePolicies$intro2, _labels$cookieConsent2, _cookiePolicies$intro3, _cookiePolicies$intro4;
  var labels = _ref.labels,
    cookiePermissions = _ref.cookiePermissions,
    setCookiePolicies = _ref.setCookiePolicies,
    manageCookies = _ref.manageCookies,
    modalStyles = _ref.modalStyles;
  var cookiePolicies = labels === null || labels === void 0 || (_labels$cookieConsent = labels.cookieConsent) === null || _labels$cookieConsent === void 0 ? void 0 : _labels$cookieConsent.cookiePolicies;
  var acceptAllCookies = () => {
    var newCookiePermissions = cookiePermissions === null || cookiePermissions === void 0 ? void 0 : cookiePermissions.map(cookiePermission => {
      if (cookiePermission.name !== 'permissionEssential') {
        return _objectSpread(_objectSpread({}, cookiePermission), {}, {
          value: true
        });
      }
      return cookiePermission;
    });
    setCookiePolicies(newCookiePermissions);
  };
  return _jsxs(Flex, _objectSpread(_objectSpread(_objectSpread({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapperStyles), cookieIntroStyle), {}, {
    "data-testid": "CookiePoliciesModal-Container",
    children: [_jsx(Flex, {
      children: _jsx(Box, _objectSpread(_objectSpread({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.textStyles.description), {}, {
        "data-testid": "CookiePoliciesModal-Description",
        children: renderSanitizedHtml(cookiePolicies === null || cookiePolicies === void 0 || (_cookiePolicies$intro = cookiePolicies.introView) === null || _cookiePolicies$intro === void 0 ? void 0 : _cookiePolicies$intro.description)
      }))
    }), _jsxs(Flex, _objectSpread(_objectSpread({
      mt: "lg"
    }, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.buttonsStyle), {}, {
      children: [_jsx(Button, {
        size: "full",
        variant: "tertiary",
        "data-testid": "CookiePoliciesModal-ManageButton",
        onClick: manageCookies,
        padding: '0 5px 0',
        children: cookiePolicies === null || cookiePolicies === void 0 || (_cookiePolicies$intro2 = cookiePolicies.introView) === null || _cookiePolicies$intro2 === void 0 ? void 0 : _cookiePolicies$intro2.manageButtonText
      }), (labels === null || labels === void 0 || (_labels$cookieConsent2 = labels.cookieConsent) === null || _labels$cookieConsent2 === void 0 || (_labels$cookieConsent2 = _labels$cookieConsent2.cookiePolicies) === null || _labels$cookieConsent2 === void 0 || (_labels$cookieConsent2 = _labels$cookieConsent2.introView) === null || _labels$cookieConsent2 === void 0 ? void 0 : _labels$cookieConsent2.necessaryOnlyButtonText) && _jsx(Button, _objectSpread(_objectSpread({
        size: "full",
        variant: "primary",
        "data-testid": "CookiePoliciesModal-NecessaryOnlyButton",
        onClick: () => setCookiePolicies()
      }, acceptAllBtnStyle), {}, {
        children: cookiePolicies === null || cookiePolicies === void 0 || (_cookiePolicies$intro3 = cookiePolicies.introView) === null || _cookiePolicies$intro3 === void 0 ? void 0 : _cookiePolicies$intro3.necessaryOnlyButtonText
      })), _jsx(Button, _objectSpread(_objectSpread({
        size: "full",
        variant: "primary",
        "data-testid": "CookiePoliciesModal-AcceptAllButton",
        onClick: acceptAllCookies
      }, acceptAllBtnStyle), {}, {
        children: cookiePolicies === null || cookiePolicies === void 0 || (_cookiePolicies$intro4 = cookiePolicies.introView) === null || _cookiePolicies$intro4 === void 0 ? void 0 : _cookiePolicies$intro4.acceptAllButtonText
      }))]
    }))]
  }));
}
var cookieIntroStyle = {
  width: {
    sm: '33.75rem',
    md: '33.375rem',
    lg: '39rem'
  }
};
var acceptAllBtnStyle = {
  mt: {
    mobile: 'md',
    sm: 0
  },
  ml: {
    md: 'xl',
    sm: 'xl',
    lg: 'xl'
  },
  padding: '0 5px 0'
};